import { InputType } from 'config/input.type.constants'

export const createUserAdditionalInputs = (): Record<string, InputType> => {
  return {
    warehouseApproved: {
      title: 'Warehouse Approved',
      inputType: 'check',
      error: '',
      required: true,
    },
  }
}
